import { useState } from "react";
import {
  SetPassword,
  Login,
  SuccessorEntryCode,
  WelcomeSuccession,
} from "../index";

interface FirstAccessProps {
  authorizedUser?: {
    email: string | null;
    canViewFiles: boolean;
    isActive: boolean;
  };
}

const FirstAccess = ({ authorizedUser }: FirstAccessProps) => {
  const [isVerified, setIsVerified] = useState(false);
  const email = authorizedUser?.email;
  const isActive = authorizedUser?.isActive;

  const onVerified = () => {
    setIsVerified(true);
  };

  if (!email) {
    return <SetPassword makeAccess={() => {}} />;
  }

  if (email && !isActive && !isVerified) {
    return <SuccessorEntryCode email={email} onVerified={onVerified} />;
  }

  if (email && (isActive || isVerified)) {
    return <WelcomeSuccession />;
  }

  return <Login first />;
};

export default FirstAccess;
